<div id="wait" *ngIf="isCreatingTemplate">
  <mat-spinner></mat-spinner>
</div>
<div class="row">
  <img class="imgBack" (click)="backBtn()" src="assets/img/backbtn.png" />
</div>
<app-meal-member-basic-details [memberDetail]="memberId"></app-meal-member-basic-details>
<div class="row mt-5 ml-2">
  <div class="title">All Meal Plans</div>
</div>
<div class="row mt-4 flex" style="padding: 0;">
  <div class="col">
    <mat-list role="list" class="flex">
      <mat-list-item class="col-md-3" role="listitem">
        <div class="tab" [ngClass]="{'active': isType === 1}">
          <div class="tabContent" (click)="getOngoingMeals()">Ongoing Meal Plan</div>
        </div>
      </mat-list-item>
      <mat-list-item class="col-md-3" role="listitem">
        <div class="tab" [ngClass]="{'active': isType === 2}">
          <div class="tabContent" (click)="getCompletedMeals()">Completed Meal Plan</div>
        </div>
      </mat-list-item>
      <mat-list-item class="col-md-3" role="listitem">
        <div class="tab" [ngClass]="{'active': isType === 3}">
          <div class="tabContent" (click)="getUpComingMeals()">Upcoming Meal Plan</div>
        </div>
      </mat-list-item>
      <mat-list-item class="col-md-3" role="listitem">
        <div class="tab" [ngClass]="{'active': isType === 4}">
          <div class="tabContent" (click)="getDraftMeals()">Draft Meal Plan</div>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
</div>
<div class="row mt-4 title1">
  <div class="col">{{mealTitle}}</div>
</div>
<div class="row mt-4" *ngIf="meals.length < 1">
  <div class="col">
    <p class="labels">No Meal Plans Found</p>
  </div>
</div>
<div class="row" *ngIf="meals.length >0">
  <div class="col-md-6 mt-4" *ngFor="let meal of meals">
    <div class="tiles">
      <div class="row mt-2">
        <div class="col-md-2">
          <img style="width: 100%;" src="assets/img/mealimg.png" />
        </div>
        <div class="col-md-10">
         <div class="row" style="margin-left: 0px;">
           <div class="col-md-10 noPad labels " *ngIf="isType !== 4"><label>{{meal.mealPlanName}}</label></div>
           <div class="col-md-10 noPad labels mealNameInputCol" *ngIf="isType === 4">
             <input type="text" class="form-control form-control-sm labels" [(ngModel)]="meal._mealPlanNameEdit" placeholder="Meal plan name" />
           </div>
           <div class="col-auto downloadIconsRow">
             <ng-container *ngIf="isType === 4">
               <img (click)="toggleMealPlanHide(meal)" class="img-down" [src]="meal.isHide === true ? 'assets/img/Property 1=eye 1.png' : 'assets/img/eye off.png'" [title]="meal.isHide === true ? 'Visible - click to hide' : 'Hidden - click to show'"/>
             </ng-container>
             <img (click)="downloadPlan(meal)" class="img-down" src="assets/img/mealpaln Download.png" title="Download meal plan"/>
             <ng-container *ngIf="isType === 4">
               <img (click)="editMealPlan(meal)" class="img-down" src="assets/img/mealplanEdit.png" title="Edit meal plan"/>
               <img (click)="openDeleteDraftConfirm(meal)" class="img-down" src="assets/img/mealPlanDelete.png" title="Delete meal plan"/>
             </ng-container>
           </div>
         </div> 
          <div class="col-md-12 noPad labelContent"><label>Date of Creation:
              {{formatDate(meal.createdDateTime)}} &nbsp;&nbsp; Time:
              {{formatTime(meal.createdDateTime)}}</label></div>
        </div>
      </div>

      <div class="row mt-2" *ngIf="isType == 4; else nonDraftDates">
        <div class="col-md-2"></div>
        <div class="col-md-10 dates left">
          <div class="row">
            <div class="col-md-6">
              <label class="labelContent d-block">Start Date:</label>
              <input
                type="date"
                class="form-control"
                [min]="meal._originalFromDate"
                [(ngModel)]="meal._fromDateEdit" />
            </div>
            <div class="col-md-6">
              <label class="labelContent d-block">End Date:</label>
              <input
                type="date"
                class="form-control"
                [min]="meal._fromDateEdit || meal._originalFromDate"
                [(ngModel)]="meal._toDateEdit" />
            </div>
          </div>
        </div>
      </div>
      <ng-template #nonDraftDates>
        <div class="row mt-2" *ngIf="meal?.fromDate && meal?.toDate">
          <div class="col-md-2"></div>
          <div class="col-md-10 dates left">
            Start Date: {{formatDate(meal.fromDate.split('T')[0])}} &nbsp;&nbsp;End Date:
            {{formatDate(meal.toDate.split('T')[0])}}
          </div>
        </div>
      </ng-template>
      <div class="row mt-4 align-items-center" *ngIf="isType == 4">
        <div class="col"></div>
        <div class="col-auto cardActionBtns cardActionBtnsRight draftTabBtns">
          <button class="btn btnOutline btnLabel1" *ngIf="meal.isAppCeatedPlan" (click)="viewPlanInputs(meal)">Plan Inputs</button>
          <button class="btn btnOutline btnLabel1" (click)="saveMealPlanAsTemplate(meal)">Create Template</button>
          <button class="btn btnOutline btnLabel1" (click)="updateDraftMealDates(meal)">Update Info</button>
          <button class="btn btnAssign btnLabel1" (click)="assignOrWarn(meal)">Assign</button>
        </div>
      </div>
      <div class="row mt-4 cardActionRow" *ngIf="isType !=4 ">
        <div class="col-md-12">
          <div class="row align-items-center">
            <!-- Completed tab: status left, To Draft and View at right end of card -->
            <ng-container *ngIf="isType == 2">
              <div class="col mt-3">
                <span><img width="20" src="assets/img/completed.png" /></span>&nbsp;&nbsp;<span>Completed</span>
              </div>
              <div class="col-auto cardActionBtns cardActionBtnsRight">
                <button class="btn btnOutline btnLabel1" *ngIf="meal.isAppCeatedPlan" (click)="viewPlanInputs(meal)">Plan Inputs</button>
                <button class="btn btnOutline btnLabel1" (click)="moveToDraft(meal)">To Draft</button>
                <button class="btn btnAssign btnLabel1"
                  (click)="viewMealPlan(meal)">View</button>
              </div>
            </ng-container>
            <!-- Upcoming tab: buttons at right end of card -->
            <ng-container *ngIf="isType == 3">
              <div class="col"></div>
              <div class="col-auto cardActionBtns cardActionBtnsRight">
                <button class="btn btnOutline btnLabel1" *ngIf="meal.isAppCeatedPlan" (click)="viewPlanInputs(meal)">Plan Inputs</button>
                <button class="btn btnOutline btnLabel1" (click)="moveToDraft(meal)">To Draft</button>
                <button class="btn btnAssign btnLabel1"
                  (click)="viewMealPlan(meal)">View</button>
              </div>
            </ng-container>
            <!-- Ongoing tab: buttons at right end of card -->
            <ng-container *ngIf="isType == 1">
              <div class="col"></div>
              <div class="col-auto cardActionBtns cardActionBtnsRight">
                <button class="btn btnOutline btnLabel1" *ngIf="meal.isAppCeatedPlan" (click)="viewPlanInputs(meal)">Plan Inputs</button>
                <button class="btn btnOutlineDanger btnLabel1" (click)="unassignMealPlan(meal)">Unassign</button>
                <button class="btn btnAssign btnLabel1"
                  (click)="viewMealPlan(meal)">View</button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create Template Success Modal -->
<div class="create-template-success-backdrop" *ngIf="showCreateTemplateSuccessModal" (click)="closeCreateTemplateSuccessModal()">
  <div class="create-template-success-content" (click)="$event.stopPropagation()">
    <div class="create-template-success-header">
      <h2 class="create-template-success-title">Success</h2>
      <button type="button" class="create-template-success-close" (click)="closeCreateTemplateSuccessModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="create-template-success-body">
      <p class="create-template-success-text">You have successfully created template of <strong>"{{ createTemplateSuccessMealPlanName }}"</strong> meal plan.</p>
      <div class="create-template-success-actions">
        <button type="button" class="btn btnAssign btnLabel1" (click)="closeCreateTemplateSuccessModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Only one meal plan can be shown for preview in the app at a time -->
<div class="create-template-success-backdrop" *ngIf="showOnlyOnePreviewModal" (click)="closeOnlyOnePreviewModal()">
  <div class="create-template-success-content" (click)="$event.stopPropagation()">
    <div class="create-template-success-header">
      <h2 class="create-template-success-title">Preview Limit Reached</h2>
      <button type="button" class="create-template-success-close" (click)="closeOnlyOnePreviewModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="create-template-success-body">
      <p class="create-template-success-text">
        At a time, one meal plan can be shown for preview in the app. Please hide the currently visible meal plan before making this one visible.
      </p>
      <div class="create-template-success-actions">
        <button type="button" class="btn btnAssign btnLabel1" (click)="closeOnlyOnePreviewModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Meal plan unavailable / needs assistance modal (shown instead of hitting the API when mealPlanId is null) -->
<div class="create-template-success-backdrop" *ngIf="showMealPlanUnavailableModal" (click)="closeMealPlanUnavailableModal()">
  <div class="create-template-success-content" (click)="$event.stopPropagation()">
    <div class="create-template-success-header">
      <h2 class="create-template-success-title">{{ mealPlanUnavailableIsAppCreated ? 'Assistance Needed' : 'Meal Plan Unavailable' }}</h2>
      <button type="button" class="create-template-success-close" (click)="closeMealPlanUnavailableModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="create-template-success-body">
      <p class="create-template-success-text" *ngIf="!mealPlanUnavailableIsAppCreated">
        This meal plan was not created successfully, so it cannot be used.
      </p>
      <p class="create-template-success-text" *ngIf="mealPlanUnavailableIsAppCreated">
        This meal plan was created by the member from the app. The member has chosen either OMAD (One Meal a Day) or a Nutritionist-assigned protocol (fasting option), so it needs your assistance to complete the meal plan creation — check the member's answers using the "Plan Inputs" button. If the member has not chosen OMAD or a Nutritionist-assigned protocol, something went wrong while creating this meal plan.
      </p>
      <div class="create-template-success-actions">
        <button type="button" class="btn btnAssign btnLabel1" (click)="closeMealPlanUnavailableModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Plan Inputs modal: view-only Q&A that Renne used to auto-generate this meal plan -->
<div class="plan-inputs-backdrop" *ngIf="planInputsModalOpen" (click)="closePlanInputsModal()">
  <div class="plan-inputs-content" (click)="$event.stopPropagation()">
    <div class="plan-inputs-header">
      <h2 class="plan-inputs-title">Plan Inputs<span *ngIf="planInputsMealName"> &middot; {{ planInputsMealName }}</span></h2>
      <button type="button" class="plan-inputs-close" (click)="closePlanInputsModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="plan-inputs-body">
      <div class="plan-inputs-state-row" *ngIf="planInputsLoading">
        <div class="plan-inputs-spinner"></div>
        <span>Loading plan inputs…</span>
      </div>
      <div class="plan-inputs-error-row" *ngIf="planInputsError && !planInputsLoading">
        {{ planInputsError }}
      </div>
      <div class="plan-inputs-empty" *ngIf="!planInputsLoading && !planInputsError && planInputsQuestions.length === 0">
        No plan input answers found for this meal plan.
      </div>
      <div class="plan-inputs-q-list" *ngIf="!planInputsLoading && !planInputsError">
        <div class="plan-inputs-q-card" *ngFor="let q of planInputsQuestions; let i = index; trackBy: trackByPlanQuestion">
          <div class="plan-inputs-q-top">
            <span class="plan-inputs-q-num">Q{{ i + 1 }}</span>
            <span class="plan-inputs-q-badge">Meal Plan</span>
          </div>
          <p class="plan-inputs-q-text">{{ q.question }}</p>

          <div class="plan-inputs-q-options" *ngIf="q.questionOptions?.length">
            <span class="plan-inputs-option-pill"
                  [ngClass]="{'plan-inputs-option-pill-selected': isPlanInputOptionSelected(q, opt)}"
                  *ngFor="let opt of q.questionOptions; trackBy: trackByPlanOption">
              {{ getOptionLabel(opt) }}
            </span>
          </div>

          <div class="plan-inputs-answer-text" *ngIf="q.answer && (!q.questionOptions?.length || q._showRawAnswer)">
            {{ q.answer }}
          </div>

          <div class="plan-inputs-free-text-wrap" *ngIf="q._showFreeText">
            <div class="plan-inputs-free-text-label">Note</div>
            <div class="plan-inputs-free-text-box">{{ q._freeText || 'No additional note provided.' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Warning modal for non-7-day draft date range (triggered from Update button) -->
<div class="modal fade" id="nonSevenDayPlanWarning" tabindex="-1" role="dialog" aria-labelledby="nonSevenDayPlanWarningLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1 w-100">Cannot Extend Meal Plan</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter padding">
        <p class="modalText">
          In this meal plan there are meals for only {{ nonSevenDayPlanDays }} days. You can extend till {{ nonSevenDayPlanMaxDate }} only.
        </p>
        <br />
        <button class="btn btnAssign btnLabel1" (click)="onNonSevenDayPlanWarningOk()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Cannot create template warning (Draft tab: Create Template button) -->
<div class="modal fade" id="cannotCreateTemplateWarning" tabindex="-1" role="dialog" aria-labelledby="cannotCreateTemplateWarningLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1 w-100">Cannot Create Template</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter padding">
        <p class="modalText">
          You can not create template of this meal plan because ' {{ cannotCreateTemplateMealName }} '  has plan for only {{ cannotCreateTemplateMealDayCount }} days.
        </p>
        <br />
        <button class="btn btnAssign btnLabel1" (click)="onCannotCreateTemplateWarningOk()">OK</button>
      </div>
    </div>
  </div>
</div>

<!-- Confirm delete draft meal plan -->
<div class="modal fade" id="confirmDeleteDraft" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteDraftLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1 w-100">Please confirm!</span>
        <button type="button" class="close" aria-label="Close" (click)="closeDeleteDraftConfirm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter padding">
        <p class="modalText">Are you sure you want to delete the "{{ toDelDraftPlanName }}"?</p>
        <br />
        <span><button class="btnConfirm btnLabel" (click)="confirmDeleteDraft()">Proceed</button></span>
        <span><button class="btnConfirm1 btnLabel1" (click)="closeDeleteDraftConfirm()">Cancel</button></span>
      </div>
    </div>
  </div>
</div>

<!-- Confirm assign meal plan to member (Draft tab) -->
<div class="modal fade" id="confirmAssignToMember" tabindex="-1" role="dialog" aria-labelledby="confirmAssignToMemberLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1 w-100">Confirm Assign</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter padding">
        <p class="modalText">Do you want to assign this meal plan to the member?</p>
        <br />
        <span><button class="btnConfirm btnLabel" (click)="confirmAssignToMember()">Confirm</button></span>
        <span><button class="btnConfirm1 btnLabel1" (click)="closeConfirmAssignToMember()">Cancel</button></span>
      </div>
    </div>
  </div>
</div>

<!-- Confirm unassign meal plan (Ongoing tab) -->
<div class="modal fade" id="confirmUnassign" tabindex="-1" role="dialog" aria-labelledby="confirmUnassignLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1 w-100">Confirm Unassign</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter padding">
        <p class="modalText">Do you want to unassign this meal plan from the member?</p>
        <br />
        <span><button class="btnConfirm btnLabel" (click)="confirmUnassign()">Confirm</button></span>
        <span><button class="btnConfirm1 btnLabel1" (click)="closeConfirmUnassign()">Cancel</button></span>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmAssign" tabindex="-1" role="dialog" aria-labelledby="confirmAssignLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1  w-100">Meal plan already Exist!</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter padding">
        <p class="modalText">You already have an active meal plan for the selected date.
          Would you like to remove or change the date for the existing meal
          plan?</p>
        <br />
        <span><button class="btnConfirm btnLabel" (click)="showcheckAssign()">Yes,
            Update the existing meal plan</button></span><span>
          <button class="btnConfirm1 btnLabel1" (click)="closeConfirmAssign()">No,
            Keep the existing meal plan</button> </span>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="checkAssign" tabindex="-1" role="dialog" aria-labelledby="checkAssignLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content modal-size-style radius">
      <div class="modal-header text-center">
        <span class="title1  w-100">Confirm Date</span>
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body textCenter">
        <p class="modalText">New Meal Plan: {{this.newMealPlan?.mealPlanName}}</p>
        <p class="modalSubText">{{this.newMealPlan?.fromDate.split('T')[0]}} -
          {{this.newMealPlan?.toDate.split('T')[0]}}
        </p>
        <p class="modalText">Existing Meal Plan: {{this.exisitngMealPlanName}}</p>
        <p class="modalSubText">{{this.existingMealPlan?.fromDate.split('T')[0]}} -
          {{this.existingMealPlan?.toDate.split('T')[0]}}
        </p>
        <p class="modalText">Please select new end date for existing meal plan</p>
        <p><mat-form-field>
            <mat-label>Pick end date</mat-label>
            <input matInput [matDatepicker]="picker2" #dateRangeEnd2 [(ngModel)]="currentDate" [min]="minDate"
              (dateChange)="setMemMealDate(dateRangeEnd2)">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field></p>
        <p class="modalSubText">You End Date will be updated to {{memMealDate}} </p>
        <button class="col-md-2 btn btnSec btnLabel1" (click)="updateAndAssign()">Confirm</button>
      </div>
    </div>
  </div>
</div>